import React, { useState, useEffect } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { connect } from "react-redux";

// Navbar for admin panel which takes user name using useEffect() from local storage, where we store user information

const AdminNavbar = (props) => {
  const commonNavLinkClass = "navbar-navlinks";
  const selectedNavLinkClass = "navbar-active-navlinks";

  const [user, setUser] = useState(null);

  useEffect(() => {
    if (props.user) {
      const user = props.user;
      setUser(user);
    }
  }, []);

  const preventDefaulrAction = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      <Navbar
        id={
          user && user.roles[0] === "museum-admin"
            ? "navbar-style"
            : "navbar-user-style"
        }
      >
        {user && user.roles[0] === "museum-admin" ? (
          <Nav id="navbar-menu" className="mr-auto">
            <Nav.Item>
              <Nav.Link
                disabled={props.loaderLoading}
                as={NavLink}
                id={
                  props.location.pathname === "/admin/visitor"
                    ? selectedNavLinkClass
                    : commonNavLinkClass
                }
                to="/admin/visitor"
              >
                Visitors
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                disabled={props.loaderLoading}
                as={NavLink}
                id={
                  props.location.pathname === "/admin/qrcode"
                    ? selectedNavLinkClass
                    : commonNavLinkClass
                }
                to="/admin/qrcode"
              >
                QRcode
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                disabled={props.loaderLoading}
                as={NavLink}
                id={
                  props.location.pathname === "/admin/upload"
                    ? selectedNavLinkClass
                    : commonNavLinkClass
                }
                to="/admin/upload"
              >
                Upload
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                disabled={props.loaderLoading}
                as={NavLink}
                id={
                  props.location.pathname === "/admin/language"
                    ? selectedNavLinkClass
                    : commonNavLinkClass
                }
                to="/admin/language"
              >
                Language
              </Nav.Link>
            </Nav.Item>
          </Nav>
        ) : null}
        <div id="user-name">
          <DropdownButton
            menuAlign="right"
            id="dropdown-menu-align-right"
            title={
              props.user
                ? props.user.firstname + " " + props.user.lastname
                : user
                ? `${user.firstname} ${user.lastname}`
                : "user"
            }
          >
            <Dropdown.Item
              disabled={props.loaderLoading}
              onClick={props.logout}
            >
              Logout
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </Navbar>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.userData.userData,
    loaderLoading: state.userData.loaderLoading,
  };
};

export default withRouter(connect(mapStateToProps, null)(AdminNavbar));
